// Strips tags/attributes that shouldn't appear in admin-authored content before it
// goes through dangerouslySetInnerHTML. Defence-in-depth, not a security boundary —
// content here has the same trust model as the committed blog markdown files.
function sanitize(input: string): string {
  return input
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<iframe[\s\S]*?<\/iframe>/gi, '')
    .replace(/\son\w+\s*=\s*(".*?"|'.*?'|\S+)/gi, '');
}

// Minimal markdown-to-HTML converter (headers, bold, italic, lists, hr, paragraphs).
// Originally lived in BlogPost.tsx; moved here so it can be reused by the "Behind
// the Song" section on /listen. No markdown library dependency in this project.
export function convertMarkdownToHTML(markdown: string): string {
  let html = sanitize(markdown);

  // Headers
  html = html.replace(/^### (.*$)/gim, '<h3 class="text-2xl font-bold text-gray-800 mt-8 mb-4">$1</h3>');
  html = html.replace(/^## (.*$)/gim, '<h2 class="text-3xl font-bold text-gray-800 mt-10 mb-6">$1</h2>');
  html = html.replace(/^# (.*$)/gim, '<h1 class="text-4xl md:text-5xl font-bold text-gray-900 mb-8">$1</h1>');

  // Bold
  html = html.replace(/\*\*(.*?)\*\*/g, '<strong class="font-bold text-gray-900">$1</strong>');

  // Lists
  html = html.replace(/^\- (.*$)/gim, '<li class="ml-6 mb-2">$1</li>');
  html = html.replace(/(<li.*<\/li>)/s, '<ul class="list-disc mb-6 text-gray-700 leading-relaxed">$1</ul>');

  // Paragraphs
  html = html.split('\n\n').map(para => {
    if (!para.startsWith('<')) {
      return `<p class="text-gray-700 leading-relaxed mb-6">${para}</p>`;
    }
    return para;
  }).join('\n');

  // Horizontal rule
  html = html.replace(/^---$/gim, '<hr class="my-8 border-gray-300" />');

  // Italics
  html = html.replace(/\*(.*?)\*/g, '<em class="italic">$1</em>');

  return html;
}
